<div class="form-modal" *ngIf="form"> 
  <h1 mat-dialog-title>{{'UPDATE_DELIVERY_DATE' | translate}} {{documentNumber}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal">
      <div class="form-group">
        <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
          <div class="col-md-4">
          <mat-form-field class="allwidth">
            <input matInput placeholder="{{ 'DELIVERY_DATE_EXPECTED' | translate}}" formControlName="EarliestAcceptableDate"
              class="one date-picker" [ngClass]="{ 'input-validation-error': formErrors.EarliestAcceptableDate }">
              <i matSuffix class="far fa-calendar-alt bigger-110"></i>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="allwidth">
            <input (onChangeDatePicker)="onLatestAcceptableDate('Order', $event)" matInput placeholder="{{ 'DELIVERY_DATE_REVISED' | translate}}" formControlName="LatestAcceptableDate"
              class="one date-picker" [ngClass]="{ 'input-validation-error': formErrors.LatestAcceptableDate }">
              <i matSuffix class="far fa-calendar-alt bigger-110"></i>
          </mat-form-field>
          <error 
            [control]="form.get('LatestAcceptableDate')"
            [checkForTouched]="false"
            [specificErrors]="{ equalDate: 'REVISED_DATE_MUST_BE_DIFFERENT_FROM_THE_TARGET_DATE'}"></error>
        </div>
        </div>
        <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
        <div class="table-responsive col-lg-12 col-md-12 col-sm-12 no-padding">
          <div *ngIf="form.controls.DetailsList.length>0">
            <div *ngIf="formErrorsDetails.length>0" class="validation-summary-errors text-danger col-md-6">
              <ul>
                <li *ngFor="let errorMessage of formErrorsDetails; let i = index" [translate] [translateParams]="formErrorsDetailsParam[i]">{{errorMessage}}</li>
              </ul>
            </div>
            <table class="update-delivery-date-table table-bordered" id="update-delivery-date-table" formArrayName="DetailsList"
              >
              <thead>
                <tr>
                  
                  <th width="4%" class="text-center">
                    <strong>#</strong>
                  </th>
                  <th width="8%">
                    <strong>{{'CODE'|translate}}</strong>
                  </th>
                  <th width="27%">
                    <strong>{{'DESCRIPTION'|translate}}</strong>
                  </th>
                  <th width="8%">
                    <strong>{{'DELIVERY_DATE_EXPECTED'|translate}}</strong>
                  </th>
                  <th width="8%">
                    <strong>{{'DELIVERY_DATE_REVISED'|translate}}</strong>
                  </th>
                </tr>
              </thead>
              <tbody *ngFor="let item of form.controls.DetailsList.controls; let i=index" [formGroupName]="i">
                <tr>
                  
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="LineNumber" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="Code" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="Description" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="DeliveryEarliestAcceptableDate" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input (onChangeDatePicker)="onLatestAcceptableDate('OrderDetail', $event, i)" matInput formControlName="DeliveryLatestAcceptableDate"
                        class="one date-picker" [ngClass]="{ 'input-validation-error': formErrors.DeliveryLatestAcceptableDate }">
                        <i matSuffix class="far fa-calendar-alt bigger-110"></i>
                    </mat-form-field>
                    <error 
                      [checkForTouched]="false"
                      [control]="item.get('DeliveryLatestAcceptableDate')" 
                      [specificErrors]="{ equalDate: 'REVISED_DATE_MUST_BE_DIFFERENT_FROM_THE_TARGET_DATE', lessThenCurrentDate: 'CANT_BE_BEFORE_THE_ACTUAL_DATE' }"></error>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="allowEdit" type="button" class="btn btn-primary" (click)="save()">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>